<template>
  <div class="mb-8">
    <h2 id="pay_off_mortgage" class="text-h2">{{ $t('L_pay_off_mortgage') }}</h2>
    <v-row class="d-flex align-center">
      <v-col
        cols="12"
        sm="8"
        md="9"
        id="pay_off_mortgage"
        :class="$vuetify.display.xs ? 'pt-4 pb-2' : 'py-0'"
      >
        <h4 class="text-h4">{{ $t('L_currently_owe') }}</h4>
      </v-col>
      <v-col cols="12" sm="4" md="3" class="mt-0" :class="$vuetify.display.xs ? 'pb-6' : 'pb-0'">
        <CurrencyDisplay
          v-model="amount"
          @update:model-value="
            $emit('update:modelValue', $event);
            $emit('input', $event);
          "
          label-id="pay_off_mortgage"
          :hide-details="true"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import Slider from '@/components/Inputs/Slider/Slider.vue';
import CurrencyDisplay from './CurrencyDisplay.vue';

const componentOptions: ComponentOptions = {
  name: 'PayOffMortgage',
  components: {
    Slider,
    CurrencyDisplay,
  },
  data: () => ({
    amount: 0,
  }),
  props: {
    modelValue: {
      type: [Number, String],
      required: true,
    },
    formInput: {
      type: Object,
      required: true,
    },
  },
  watch: {
    modelValue(value) {
      this.amount = value;
    },
  },
  mounted() {
    this.amount = this.modelValue;
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
:deep(.v-text-field input) {
  padding: 0 !important;
}
</style>
